import React from 'react'
import CardStep from '../CardStep/CardStep'
import './EasyGestion.scss'
import useAppContext from '../../context/Context'
const EasyGestion = () => {
    const { activeCountry } = useAppContext();

    return (
        <div className="container-easy-gestion">
            <div className='easy-gestion'>
                <p className='tag'>Todo conectado</p>
                <h3 className='title'>Fácil de gestionar</h3>
                <p className='subtitle'>Crea, comparte y revisa todos las transacciones gracias al ETpay Dashboard</p>
                <div className="container-card-step">
                    <CardStep step={'Uno'} title={'Introduce la cantidad que necesitas recibir.'} image={`/content/card-pl-${activeCountry}.png`}></CardStep>
                    <CardStep step={'Dos'} title={'Comparte con tu cliente de la manera que necesites.'} image={`/content/card-pl-${activeCountry}-2.png`}></CardStep>
                    <CardStep step={'Tres'} title={'Podrás hacer un seguimiento íntegro de cada transacción.'} image={`/content/card-pl-${activeCountry}-3.png`}></CardStep>
                </div>
            </div>
        </div>
    )
}

export default EasyGestion